// 默认客服电话
const DEFAULT_SERVICE_PHONE_TEXT = '400-820-1552'
const DEFAULT_SERVICE_PHONE_NUMBER = '4008201552'
// 雁宝健康客服电话
const BYJK_SERVICE_PHONE_TEXT = '400-679-9297'
const BYJK_SERVICE_PHONE_NUMBER = '4006799297'

function getStorageValue(key: string) {
  return sessionStorage.getItem(key) || localStorage.getItem(key) || ''
}

/** terminal=58 或 platformCode=BYJK 时为雁宝健康渠道 */
export function isByjkChannel() {
  const terminal = getStorageValue('terminal')
  const platformCode = getStorageValue('platformCode')
  return terminal === '58' || platformCode === 'BYJK'
}

/** 展示用客服电话，如 400-820-1552 */
export function getServicePhoneText() {
  return isByjkChannel() ? BYJK_SERVICE_PHONE_TEXT : DEFAULT_SERVICE_PHONE_TEXT
}

/** 拨打用客服电话，如 tel:4008201552 */
export function getServicePhoneTel() {
  return isByjkChannel() ? `tel:${BYJK_SERVICE_PHONE_NUMBER}` : `tel:${DEFAULT_SERVICE_PHONE_NUMBER}`
}